// Screen ↔ world coordinate transforms. Take state explicitly so
// they're pure: state.camera (x, y, zoom) + canvas dimensions are the
// only inputs. zoom is in pixels-per-meter.

export function screenToWorld(state, canvas, sx, sy) {
  const w = canvas.width, h = canvas.height;
  return {
    x: (sx - w / 2) / state.camera.zoom + state.camera.x,
    y: (sy - h / 2) / state.camera.zoom + state.camera.y,
  };
}

export function worldToScreen(state, canvas, wx, wy) {
  const w = canvas.width, h = canvas.height;
  return {
    x: (wx - state.camera.x) * state.camera.zoom + w / 2,
    y: (wy - state.camera.y) * state.camera.zoom + h / 2,
  };
}
